import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import SnacksList from '../components/SnacksList';
import Loading from '../components/Loading';
import Error from '../components/Error';
import Footer from '../components/Footer';
import OrderModalContainer from '../components/OrderModalContainer';
import { fetchSnacks } from '../services/api';
import { useCart } from '../context/CartContext';

const SnacksPage = () => {
  const [snacks, setSnacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { cartItems } = useCart();
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  useEffect(() => {
    const getSnacks = async () => {
      try {
        setLoading(true);
        const data = await fetchSnacks();
        if (data && data.ResponseCode === 0 && data.ConcessionItems) {
          setSnacks(data.ConcessionItems);
        } else {
          setError('Invalid response format');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch snacks');
      } finally {
        setLoading(false);
      }
    };

    getSnacks();
  }, []);

  return (
    <>
      <Header 
        searchQuery={searchQuery} 
        setSearchQuery={setSearchQuery} 
        cartCount={totalItems}
      />
      
      <main className="main-content">
        {loading ? (
          <Loading />
        ) : error ? (
          <Error message={error} />
        ) : (
          <SnacksList snacks={snacks} searchQuery={searchQuery} />
        )}
      </main>
      
      <Footer />
      
      {/* Render the OrderSuccessModal inside the Router context */}
      <OrderModalContainer />
    </>
  );
};

export default SnacksPage;
